import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import { useAllCustomers } from "../../../hooks/useCustomer";
import { useTranslation } from "react-i18next";

export type SelectCustomerFeatureFlagsProps = {
  selectedCustomerId: string | null;
  onChangeCustomer: React.Dispatch<React.SetStateAction<string | null>>;
};
export default function SelectCustomerFeatureFlags({
  selectedCustomerId,
  onChangeCustomer,
}: Readonly<SelectCustomerFeatureFlagsProps>) {
  const { t } = useTranslation("common");
  const { data: customers, isLoading } = useAllCustomers();

  return (
    <Box sx={{ mb: 3, width: 300 }}>
      <FormControl fullWidth size="small" disabled={isLoading}>
        <InputLabel id="customer-select-label">
          {t("common:selectCustomer")}
        </InputLabel>
        {isLoading ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={40}
          >
            <CircularProgress size={20} />
          </Box>
        ) : (
          <Select
            labelId="customer-select-label"
            value={selectedCustomerId ?? ""}
            label="Select Customer"
            onChange={(e) => onChangeCustomer(e.target.value ?? null)}
          >
            <MenuItem value="">All Customers</MenuItem>
            {customers?.map((customer) => (
              <MenuItem key={customer.customerId} value={customer.customerId}>
                {customer.name}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </Box>
  );
}
